import { render, staticRenderFns } from "./AppDropZone.vue?vue&type=template&id=03e37fa6&"
import script from "./AppDropZone.vue?vue&type=script&lang=js&"
export * from "./AppDropZone.vue?vue&type=script&lang=js&"
import style0 from "./AppDropZone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports